export default class Environment {
	static readonly LIVE = "live";
	static readonly TEST = "test";
	static readonly SANDBOX = "sandbox";
	static readonly STAGING = "staging";
}